import { useTranslation } from "react-i18next";

export default function LoadFailed({ text, onRetry }: { text: string; onRetry: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
      {text}
      <button type="button" onClick={onRetry} className="ml-3 rounded-md border border-red-300 bg-white px-3 py-1 hover:bg-red-100">
        {t("retry")}
      </button>
    </div>
  );
}
